import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/stable';
import 'events-polyfill';
// import 'core-js/es/map';
// import 'core-js/es/set';
// import 'raf/polyfill';
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Auth0Provider } from "./react-auth0-spa";
import history from "./utils/history";
// import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";

import common from './store/reducers/common';
import signatureApp from './store/reducers/signatureAppApi';
import qmsApi from './store/reducers/qmsApi';
import filetraceReducers from './store/reducers/filetraceReducers';
import sidebarReducers from './store/reducers/sidebarReducers';
import navbarReducers from './store/reducers/navbarReducers';
import complianceTableReducer from './store/reducers/complianceTableReducers';
import appPermissionsReducer from './store/reducers/appPermissionsReducer';
import userDetailReducer from './store/reducers/userDetailReducer';
import signatureDetailsPopupReducer from './store/reducers/signatureDetailsPopupReducer';
import popupStatusReducer from './store/reducers/popupStatusReducer';
import groupingModalReducer from './store/reducers/groupingModalReducer';
import controlledComponentsReducer from './store/reducers/controlledComponentsReducer';
import CommonConfig from "./components/commonConfig.json";

const ENVS = CommonConfig.envs;
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  common: common,
  signatureApp: signatureApp,
  qmsApi: qmsApi,
  filetraceReducer : filetraceReducers,
  sidebarReducer : sidebarReducers,
  navbarReducer : navbarReducers,
  complianceTableReducer : complianceTableReducer,
  appPermissionsReducer : appPermissionsReducer,
  userDetailReducer : userDetailReducer,
  signatureDetailsPopupReducer : signatureDetailsPopupReducer,
  popupStatusReducer : popupStatusReducer,
  groupingModalReducer : groupingModalReducer,
  controlledComponentsReducer : controlledComponentsReducer
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const onRedirectCallback = appState => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};
//Auth0 connfig
const config = {
  "domain": process.env["REACT_APP_AUTH0_DOMAIN"],
  "clientId": process.env["REACT_APP_AUTH0_CLIENT"],
  "audience":process.env["REACT_APP_AUTH0_AUDIENCE"]
}

if(!window.location.origin){
  window.location.origin = window.location.protocol+"//"+window.location.hostname+(window.location.port?":":"");
}

//stop clickjacking
if(window.self === window.top){
  if(process.env["REACT_APP_DEP_LOCATION"] === "prod" && process.env["REACT_APP_HMG"] === ENVS.MARRIOTT){
    ReactDOM.render(
      <Provider store={store}>
          <Auth0Provider
            domain={config.domain}
            client_id={config.clientId}
            redirect_uri={window.location.origin}
            onRedirectCallback={onRedirectCallback}
            audience={config.audience}
            /* Add when Marrriott Go Live for SAML */
            prompt="none"
          >
            <App />
          </Auth0Provider>
        </Provider>
      ,
      document.getElementById("root")
    );
  } else {
    ReactDOM.render(
      <Provider store={store}>
          <Auth0Provider
            domain={config.domain}
            client_id={config.clientId}
            redirect_uri={window.location.origin}
            onRedirectCallback={onRedirectCallback}
            audience={config.audience}
            /* Add when Marrriott Go Live for SAML */
            // prompt="none"
          >
            <App />
          </Auth0Provider>
        </Provider>
      ,
      document.getElementById("root")
    );
  }

}

serviceWorker.unregister();
